import React from "react";
import img2 from "../assets/whoWeAre/partners/img1.png";
import img3 from "../assets/whoWeAre/partners/img2.png";
import img4 from "../assets/whoWeAre/partners/img4.png";
import img5 from "../assets/whoWeAre/partners/Devaraj.jpeg";
import gran from "../components/home/whoweare/gran.png";
import { motion } from "framer-motion";

// Team Members Data
const teamMembers = [
  {
    name: "Muthu Lakshmi J ",
    role: "Partner",
    image: img2,
  },
  {
    name: "Vanitha V",
    role: "Partner",
    image: img4,
  },
  {
    name: "Kavitha V",
    role: "Partner",
    image: img3,
  },
  {
    name: "Devaraj C",
    role: "Plant Head",
    image: img5,
  },
  {
    name: "V.V Mukesh",
    role: "Administrator",
    image: gran,
  },
];

// Typewriter Effect Variants
const letterAnimation = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.05, // delay each letter
    },
  }),
};

const Team = () => {
  const heading = "Meet Our Skilled and Experienced Team.";

  return (
    <section className="py-20 bg-blue-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        {/* Section Heading with Typewriter Animation */}
        <motion.h2
          className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 flex flex-wrap justify-center"
          initial="hidden"
          animate="visible"
        >
          {heading.split("").map((char, i) => (
            <motion.span key={i} custom={i} variants={letterAnimation}>
              {char === " " ? "\u00A0" : char}
            </motion.span>
          ))}
        </motion.h2>

        {/* Subheading Fade In */}
        <motion.p
          className="text-gray-600 max-w-2xl mx-auto text-base sm:text-lg md:text-xl mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.5, duration: 0.8 }}
        >
          With over 45 years of expertise, our dedicated team blends
          technical precision with innovation to deliver world-class fasteners
          and machined components for the automotive, agricultural, and aerospace
          industries.
        </motion.p>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 items-start">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              className="text-center group"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="relative overflow-hidden rounded-2xl shadow-lg">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[400px] object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                />

                {/* Name + Role */}
                <div className="mt-4 flex flex-col p-3 items-start">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-semibold">
                    {member.name}
                  </h3>
                  <p className="text-gray-500 text-sm sm:text-base md:text-lg">
                    {member.role}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
